export default __webpack_public_path__ + "static/media/iread10.42f29a7c.jpeg";